import Fetcher from './base'
import { getToken } from '@/lib/services/auth.service'

export default new Fetcher({ baseUrl: process.env.NEXT_PUBLIC_API_BASE_URL, token: getToken().access_token })